const todayString = new Date().toLocaleDateString('es-GT', { day: 'numeric', month: 'long', year: 'numeric', })

const fechaSinGuiones = (fecha) => {  // YYYY-MM-DD YYYYMMDD
    let fechaentera = '';
    return fechaentera = fecha.split('-').join('') 
  }
  
  function formatearFechaDiagonalesDDMMYY(fecha) {  // YYYY-MM-DD DD/MM/YYYY
 
    let anio = fecha.substring(0, 4);
    let mes = fecha.substring(5, 7);
    let dia = fecha.substring(8, 10);
    let fechasinformato = `${dia}/${mes}/${anio}`;

    return fechasinformato;
}

  function formatearFechaDiagonales(fecha) {  // DD-MM-YYYY DD/MM/YYYY
 
      let dia = fecha.substring(0, 2);
      let mes = fecha.substring(3, 5);
      let anio = fecha.substring(6, 10);
      let fechasinformato = `${dia}/${mes}/${anio}`;

      return fechasinformato;
  }
  
  function formatearFechaASinDiagonales(fecha) { // DD/MM/YYYY YYYYMMDD
    
      let dia = fecha.substring(0, 2);
      let mes = fecha.substring(3, 5);
      let anio = fecha.substring(6, 10);
      let fechasinformato = `${anio}${mes}${dia}`;

      return fechasinformato;  
  }
  
  function formatearFechaGuiones(fecha) {  // DD/MM/YYYY  YYYY-MM-DD
    if (fecha !== undefined) {
      let dia = fecha.substring(0, 2);
      let mes = fecha.substring(3, 5);
      let anio = fecha.substring(6, 10);
      let fechasinformato = `${anio}-${mes}-${dia}`;

      return fechasinformato;
    }
  }

  function formatearFechaHoraGuiones(fecha) {  // DD/MM/YYYY  YYYY-MM-DDTHH:MM:SS
    if (fecha !== undefined) {
      let dia =  fecha.substring(0, 2);
      let mes =  fecha.substring(3, 5);
      let anio = fecha.substring(6, 10);
      let hora = fecha.substring(11,19);
      let fechasinformato = `${anio}-${mes}-${dia}T${hora}`;

      return fechasinformato;
    }
  }

  const aFechaConDiagonales = (fecha) => { //YYYY-MM-DD  //YYYYMMDD 
    let anio = fecha.substring(0, 4);
    let mes = fecha.substring(5, 7);
    let dia = fecha.substring(8, 10);

    //return `${dia}/${mes}/${anio}`
    return `${anio}${mes}${dia}`;
  };

  const sinDiagonalesYYMMDD = (fecha) => { //DD/MM/YYYY  YYYYMMDD
    let dia  = fecha.substring(0,2)
    let mes  = fecha.substring(3,5)
    let anio = fecha.substring(6,10)
    return `${anio}${mes}${dia}`
  }

  const getFechaActual = () => {
    let fecha = new Date();
    let dia = `${fecha.getDate()}`.padStart(2,0);
    let mes = `${fecha.getMonth() + 1}`.padStart(2,0);
    let anio = fecha.getFullYear();
    return { "day": dia, "month": mes, "year": anio }
  };

  export {
    fechaSinGuiones,
    formatearFechaDiagonalesDDMMYY,
    formatearFechaDiagonales,
    formatearFechaASinDiagonales,
    formatearFechaGuiones,
    sinDiagonalesYYMMDD,
    aFechaConDiagonales,
    todayString,
    getFechaActual,
    formatearFechaHoraGuiones,
  }